import React, { useEffect, useRef } from 'react';
import {Link} from "react-router-dom";

import { Swiper, Navigation, Pagination, Lazy, Autoplay } from 'swiper/js/swiper.esm';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import 'swiper/swiper.scss';

const ReviewsSlider = (props) => {
    const swiperRef = useRef(null);

    const goNext = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const userEventStart = () => {
        const { swiper } = swiperRef.current;
        swiper.autoplay.stop();
        const activeSlide = document.getElementsByClassName('reviews__list-item')[swiper.activeIndex];
        activeSlide.classList.remove('play-timeline', 'hide-content');
    };

    const userEventEnd = () => {
        const { swiper } = swiperRef.current;
        const activeSlide = document.getElementsByClassName('reviews__list-item')[swiper.activeIndex];
        swiper.slideTo(swiper.activeIndex, 0, false);
        swiper.autoplay.start();
        activeSlide.classList.add('play-timeline', 'hide-content');
    };

    const pageFocus = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            userEventEnd();
        }
    };

    const pageBlur = () => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            userEventStart();
        }
    };

    const pauseOnHover = () => {
        const w = window.innerWidth;

        if(w > 992) {
            userEventStart();
        }
    };

    const palayOnMouseLeave = () => {
        const w = window.innerWidth;

        if(w > 992) {
            userEventEnd();
        }
    };

    const mobileUserTouchStart = () => {
        const w = window.innerWidth;

        if(w < 991) {
            userEventStart();
        }
    };

    const mobileUserTouchEnd = () => {
        const w = window.innerWidth;

        if(w < 991) {
            userEventEnd();
        }
    };

    useEffect(() => {
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
            const { swiper } = swiperRef.current;
            swiper.on("touchStart", mobileUserTouchStart);
            swiper.on("touchEnd", mobileUserTouchEnd);
            window.addEventListener('focus', pageFocus);
            window.addEventListener('blur', pageBlur);
        }

        return () => {
            if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
                const { swiper } = swiperRef.current;
                swiper.off("touchStart", mobileUserTouchStart);
                swiper.off("touchEnd", mobileUserTouchEnd);
                window.removeEventListener('focus', pageFocus);
                window.removeEventListener('blur', pageBlur);
            }
        };
    }, [mobileUserTouchStart, mobileUserTouchEnd, pageFocus, pageBlur]);

    const params = {
        Swiper,
        modules: [Navigation, Pagination, Lazy, Autoplay],
        spaceBetween: 0,
        loop: true,
        slidesPerView: 1,
        lazy: true,
        preloadImages: false,
        loopedSlides: 1,
        freeModeFluid : true,
        watchSlidesVisibility: true,
        speed: 1,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination.reviews__pagination',
            clickable: true
        },
        shouldSwiperUpdate: true,
        rebuildOnUpdate: true,
    };

    let w = window.innerWidth;

    const reviewsStructedData = props.sliderData.map((item) => {
        let reviewAutor = item.author_name
        let reviewText = item.review_text.replace(/(<([^>]+)>)/ig, '')
        let reviewName = item.review_name
        
        return {
            "@context": "https://schema.org/",
            "@type": "Review",
            "itemReviewed": {
                "@type": "Organization",
                "name": "alkima WEB & DESIGN ®",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Colmarer Str. 12",
                    "addressLocality": "Wiesbaden",
                    "postalCode": "65203",
                    "addressCountry": "DE"
                },
            },
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5"
            },
            "name": `${reviewName}`,
            "author": {
                "@type": "Person",
                "name": `${reviewAutor}`
            },
            "reviewBody": `${reviewText}`
        }
    })

    return (
        <div className="reviews__container">
            {reviewsStructedData.map((item) => {
                return (
                    <script className='structured-data-list' type="application/ld+json" key={item.author_name}>
                        {JSON.stringify(item)}
                    </script>
                )
            })}
            <div className="reviews__content">
                <div className="reviews__header">
                    <h2 className="reviews__title">{props.sectionData.section_title}</h2>
                    <div className="reviews__title-bg">{props.sectionData.section_title_bg}</div>
                    {
                        w >= 992 ? (
                            <div className="reviews__link-show-all">
                                <Link to='/referenzen' className="base-btn">{props.sectionData.label_of_link}</Link>
                            </div>
                        ): ('')
                    }
                </div>

                <div className="reviews__list swiper-container gallery-top" onMouseEnter={()=>pauseOnHover()} onMouseLeave={()=>palayOnMouseLeave()}>
                    <ReactIdSwiperCustom {...params} ref={swiperRef}>
                        {
                            props.sliderData.map((item, key) => {

                                if (w < 992) {
                                    return (
                                        <div className="reviews__list-item show-content play-timeline hide-content" key={key}>
                                            <div className="review">
                                                <div className="review__project-logo">
                                                    {
                                                        key === 0 ?
                                                            <img src={item.project_logo.url} alt={item.project_logo.alt}/>
                                                            :
                                                            <img data-src={item.project_logo.url} alt={item.project_logo.alt} className="swiper-lazy" />
                                                    }
                                                </div>
                                                <div className="review__photo-col">
                                                    <div className="review__project-mockup">
                                                        {
                                                            key === 0 ?
                                                                <img src={item.project_mockup.url} alt={item.project_mockup.alt} />
                                                                :
                                                                <img src="data:image/png;base64,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"
                                                                     data-src={item.project_mockup.url}
                                                                     alt={item.project_mockup.alt}
                                                                     className="swiper-lazy" />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="review__progress-bar">
                                                    <div className="progress-bar progress-bar__mobile">
                                                        <div className="progress-bar__before"></div>
                                                        <div className="progress-bar__center">
                                                            <div className="progress-bar__photo">
                                                                {
                                                                    key === 0 ?
                                                                        <img src={item.author_photo.url} alt={item.author_photo.alt} />
                                                                        :
                                                                        <img data-src={item.author_photo.url} alt={item.author_photo.alt} className="swiper-lazy" />
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="progress-bar__after"></div>
                                                    </div>
                                                </div>
                                                <div className="review__detailinfo-col">
                                                    <div className="review__detailinfo-wrap">
                                                        <div className="review__detailinfo-parallax">
                                                            <div className="author__name">{item.author_name}</div>
                                                            <div className="author__position">{item.author_position}</div>
                                                            <div className="review__text" dangerouslySetInnerHTML={{__html: item.review_text}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className="reviews__list-item show-content play-timeline hide-content" key={key}>
                                            <div className="review">
                                                <div className="review__detailinfo-col">
                                                    <div className="review__detailinfo-wrap">
                                                        <div className="review__detailinfo-parallax">
                                                            <div className="author__photo">
                                                                {
                                                                    key === 0 ?
                                                                        <img src={item.author_photo.url} alt={item.author_photo.alt} />
                                                                        :
                                                                        <img data-src={item.author_photo.url} alt={item.author_photo.alt} className="swiper-lazy" />
                                                                }
                                                            </div>
                                                            <div className="author__name">{item.author_name}</div>
                                                            <div className="author__position">{item.author_position}</div>
                                                            <div className="review__text" dangerouslySetInnerHTML={{__html: item.review_text}}/>
                                                        </div>
                                                        <div className="review__project-logo">
                                                            {
                                                                key === 0 ?
                                                                    <img src={item.project_logo.url} alt={item.project_logo.alt}/>
                                                                    :
                                                                    <img data-src={item.project_logo.url} alt={item.project_logo.alt} className="swiper-lazy" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="review__photo-col">
                                                    <div className="review__project-mockup">
                                                        {
                                                            key === 0 ?
                                                                <img src={item.project_mockup.url} alt={item.project_mockup.alt} />
                                                                :
                                                                <img src="data:image/png;base64,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"
                                                                     data-src={item.project_mockup.url}
                                                                     alt={item.project_mockup.alt}
                                                                     className="swiper-lazy" />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="progress-bar progress-bar__desktop"></div>
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        }
                    </ReactIdSwiperCustom>
                </div>

                <div className="reviews__slide-btn-prev" onClick={goPrev}>
                    <i className="icon-angle-left"></i>
                </div>
                <div className="reviews__slide-btn-next" onClick={goNext}>
                    <i className="icon-angle-right"></i>
                </div>

                {
                    w < 992 ? (
                        <div className="reviews__footer">
                            <div className="reviews__link-show-all">
                                <Link to='/referenzen' className="base-btn">
                                    {props.sectionData.label_of_link}
                                </Link>
                            </div>
                        </div>
                    ): ('')
                }
            </div>
        </div>
    );
};

export default ReviewsSlider;
